
<!--订单块标题-->
<template>
    <div class="caption-title van-hairline--top-bottom">
        <img class="cpation_icon" :src="capIcon" />
        <span>{{title}}</span>
    </div>
</template>

<script>
    import defIcon from './img/icon_1.png';

    export default {
        name: 'OrderCaption',
        props: {
            title: {
                type: String,
                default: '服务信息',
            },
            capIcon: {
                type: String,
                default: defIcon,
            },
        },
    }
</script>

<style lang="scss" scoped>
    .caption-title {
        display: flex;
        align-items: center;
        padding: 20px 16px;
        font-size: 17px;
        font-weight: 400;
        color: rgba(34, 34, 34, 1);
        .cpation_icon {
            width: 16px;
            margin-right: 10px;
        }
    }
</style>
